import { createAction } from 'typesafe-actions';
import { IFirestoreNotification } from '../../types/model/notification';

export default class NotificationsActions {
    public static setNotifications = createAction('NOTIFICATIONS_SET', resolve => (notifications : Array<IFirestoreNotification>) => resolve(notifications));
}